import type {
  CreatePostTypeReq,
  PostTypeDataType,
  ReadPostTypeRes,
  UpdatePostTypeReq,
} from '../../Types/Api/PostType'
import { api } from './API'
import { requireAuth } from './Auth'

export const findAllPostType = async (name) => {
  const res = await requireAuth<any>(
    api.get('post_types', {
      order_by: 'asc',
      queryType: 'all',
      site_name: name,
    }),
  )

  if (res.ok) {
    return res.data.data
  }

  return []
}

export const findPostType = async (id: number) => {
  return await requireAuth<ReadPostTypeRes>(api.get(`post_types/${id}`))
}

export const createPostType = (values: CreatePostTypeReq) => {
  return requireAuth<PostTypeDataType>(api.post(`post_types`, values))
}

export const updatePostType = (values: UpdatePostTypeReq) => {
  return requireAuth<PostTypeDataType>(
    api.put(`post_types/${values.id}`, values),
  )
}
